import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { DASHBOARD_ROUTE, TERMS_AND_CONDITIONS } from "../../../../../routes";
import MixedFileUploadButton from "../input/mixed-file-upload-btn";
import FormData from "form-data";
import axios from "axios";
import dataProvider from "../../../../../services/dataProvider";
import authServices from "../../../../../services/authServices";
import qs from "qs";
import { FORMS_ROUTE, SUBMITTED_FORMS_ROUTE } from "../../../dashboard-routes";
import SelfDeclaration from "../bucket-1/common/self-declaration";
import { useHistory, useLocation } from "react-router";
import downloadForm from "../download-form";
import getAssociatedTask from "../getAssociatedTask";
import AssociatedTask from "../../../common/associated-task";
import { markTaskComplete } from "../../../common/mark-task-complete";

const SG2PolicyAndProcedureForm = ({ bucket, formType, formTitle }) => {
    const formPath = "Bucket2Forms/sg2-policy-and-procedure-manual.docx";

    let baseState = {
        formType,
        formTitle,
        bucket,
        nameOfPersonCompletingForm: "",
        dateOfFormCompletionInString: "",
        dateOfFormCompletionInMilliSeconds: 0,
        tncAgreed: false,
        SG2PolicyAndProcedureFormFile: "",
        SG2PolicyAndProcedureFormFileDisplayName: "",
    };

    const [successMsg, setSuccessMsg] = useState("");
    const [isFetching, setIsFetching] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isDownloading, setIsDownloading] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const [formState, setFormState] = useState(baseState);
    const [editMode, setEditMode] = useState(false);
    const [associatedTask, setAssociatedTask] = useState(null);
    const [completeTask, setCompleteTask] = useState(true);

    const history = useHistory();
    const location = useLocation();

    useEffect(() => {
        if (location?.state?.editForm === true) {
            if (location?.state?.formState) {
                setEditMode(true);
                setIsFetching(true);
                let editFormState = location.state.formState;
                let cleanEditFormState = {
                    formType,
                    formTitle,
                    bucket,
                    nameOfPersonCompletingForm: editFormState.nameOfPersonCompletingForm,
                    dateOfFormCompletionInString: editFormState.dateOfFormCompletionInString,
                    dateOfFormCompletionInMilliSeconds: editFormState.dateOfFormCompletionInMilliSeconds,
                    tncAgreed: editFormState.tncAgreed === "true",
                    editFormId: editFormState.id,
                    SG2PolicyAndProcedureFormFile: editFormState.SG2PolicyAndProcedureFormFile,
                    SG2PolicyAndProcedureFormFileDisplayName: editFormState.SG2PolicyAndProcedureFormFileDisplayName,
                };
                setFormState(cleanEditFormState);
                setFile(
                    editFormState.SG2PolicyAndProcedureFormFileDisplayName,
                    editFormState.SG2PolicyAndProcedureFormFile,
                    true
                );

                // console.log(editFormState.formId);
                getAssociatedTask(formType)
                    .then((res) => {
                        // console.log("RES",res);
                        setIsFetching(false);
                        if (res.data && res.data.length > 0) {
                            let task = res.data[0];
                            setAssociatedTask(task);
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                    });
            }
        }
    }, []);

    function handleSubmit(e) {
        e.preventDefault();
        setIsLoading(true);
        setSuccessMsg("");
        setErrorMsg("");

        let endPoint = editMode ? "forms-editFormDetails" : "forms-addFormDetails";
        var data = new FormData();

        for (var key in formState) {
            if (formState[key]?.isLink === true && formState[key].link) {
                data.append(key, formState[key].link);
            } else {
                data.append(key, formState[key]);
            }
        }

        // for (var pair of data.entries()) {
        //     console.log(pair)
        // }

        var config = {
            method: "post",
            url: dataProvider.baseUrl + endPoint,
            headers: {
                token: authServices.getToken(),
                orgid: authServices.getOrgId(),
            },
            data: data,
        };

        axios(config)
            .then(function (response) {
                // console.log("submit form", response);
                setIsLoading(false);
                if (response.data.status === "success") {
                    if (completeTask && associatedTask) {
                        markTaskComplete(associatedTask.id).then((res) => {
                            // console.log("TASK COM", res);
                            if (res.data.status === "success") {
                                history.push({
                                    pathname: DASHBOARD_ROUTE + SUBMITTED_FORMS_ROUTE,
                                    state: {
                                        successMsg:
                                            editMode === true
                                                ? "Form Updated Successfully"
                                                : "Form Submitted Successfully",
                                    },
                                });
                            } else {
                                setErrorMsg("Unable to Complete the Task");
                            }
                        });
                    } else {
                        history.push({
                            pathname: DASHBOARD_ROUTE + SUBMITTED_FORMS_ROUTE,
                            state: {
                                successMsg:
                                    editMode === true ? "Form Updated Successfully" : "Form Submitted Successfully",
                            },
                        });
                    }
                } else {
                    setErrorMsg("Something Went Wrong");
                }
            })
            .catch(function (error) {
                setIsLoading(false);
                setErrorMsg(error.message);
                console.error(error);
            });
    }

    function setFile(file, link = "", isLink = false) {
        let fileObj;

        //console.log("SET FILE", file, link, isLink);

        if (!file) {
            setFormState((fs) => ({
                ...fs,
                SG2PolicyAndProcedureFormFile: {},
                SG2PolicyAndProcedureFormFileDisplayName: "",
            }));
            return;
        }

        if (isLink === true) {
            fileObj = {
                name: file,
                isLink: true,
                link,
            };
        } else {
            fileObj = file;
            fileObj.isLink = false;
        }

        //console.log("File object", fileObj);

        setFormState((fs) => ({
            ...fs,
            SG2PolicyAndProcedureFormFile: fileObj,
            SG2PolicyAndProcedureFormFileDisplayName: fileObj.name,
        }));
    }

    return (
        <div id="sg1-fair-trading-notification-form">
            <div className="container-fluid p-0">
                <div className="card p-4 m-0 no-radius border-0 flex-row align-items-center border-bottom">
                    <h5 className="m-0">{formTitle}</h5>
                    <div className="flex-fill"></div>
                    {isDownloading ? (
                        <button className="btn btn-primary text-white d-flex align-items-center" disabled>
                            Downloading
                            <div
                                className="spinner-border spinner-border-sm text-primary text-white ms-2"
                                role="status"
                            >
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </button>
                    ) : (
                        <button
                            onClick={() => {
                                downloadForm(formPath, formType, formTitle, setIsDownloading);
                            }}
                            className="btn btn-primary text-white"
                        >
                            Download Form
                        </button>
                    )}
                </div>
            </div>

            {successMsg && !errorMsg && (
                <div className="container-fluid py-0 mt-3 px-3">
                    <div className="alert alert-success m-0" role="alert">
                        {successMsg}
                    </div>
                </div>
            )}

            {errorMsg && (
                <div className="container-fluid py-0 mt-3 px-3">
                    <div className="alert alert-danger m-0" role="alert">
                        {errorMsg}
                    </div>
                </div>
            )}

            {isFetching ? (
                <div className="container-fluid p-3">
                    <div className="card p-3">
                        <div className="">
                            <div className="d-flex align-items-center justify-content-center">
                                <div className="me-3">Fetching Form Data</div>
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="container-fluid p-3">
                    <div className="card p-3 py-5">
                        <form className="w-100 mx-auto" style={{ maxWidth: "60rem" }} onSubmit={handleSubmit}>
                            <div className="row mx-auto w-100 mb-5" style={{ maxWidth: "40rem" }}>
                                <div className="col-md-4 d-flex align-items-center">Upload Form :</div>
                                <div className="col-md">
                                    <MixedFileUploadButton
                                        setFile={setFile}
                                        file={formState.SG2PolicyAndProcedureFormFile}
                                    />
                                </div>
                            </div>

                            {associatedTask && (
                                <AssociatedTask
                                    task={associatedTask}
                                    completeTask={completeTask}
                                    setCompleteTask={setCompleteTask}
                                />
                            )}

                            <SelfDeclaration
                                formState={formState}
                                setFormState={setFormState}
                                isLoading={isLoading}
                                editMode={editMode}
                            />
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

export default SG2PolicyAndProcedureForm;
